"use client";

import { ReCaptchaProvider } from "next-recaptcha-v3";
import { PropsWithChildren } from "react";

interface IProvidersProps {}

const Providers: React.FC<PropsWithChildren<IProvidersProps>> = ({ children }) => {
	return (
		<ReCaptchaProvider
			useEnterprise
			reCaptchaKey={
				process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY || "6Lc_nrAqAAAAAA2XL_OoglIcenwb9pNia43Yjk-j"
			}
		>
			{children}
		</ReCaptchaProvider>
	);
};
export default Providers;
